// AUTO-GENERATED by scripts/extract-bestiary.mts from docs/franchise/bestiary.jsx.
// Do not edit by hand. Re-run the script if the bestiary changes.

import type { CreatureShape } from "./types.ts";

export const BESTIARY: readonly CreatureShape[] = [
  { id: 0, tier: 1, cells: [[0, 0]], nameDe: "Keim", mirrorSymmetric: true },
  {
    id: 1,
    tier: 2,
    cells: [
      [0, 0],
      [0, 1],
    ],
    nameDe: "Zwilling",
    mirrorSymmetric: true,
  },
  {
    id: 2,
    tier: 2,
    cells: [
      [0, 0],
      [1, 0],
    ],
    nameDe: "Säule",
    mirrorSymmetric: true,
  },
  {
    id: 3,
    tier: 2,
    cells: [
      [0, 0],
      [1, 1],
    ],
    nameDe: "Schrägling",
    mirrorSymmetric: false,
  },
  {
    id: 4,
    tier: 3,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
    ],
    nameDe: "Strich",
    mirrorSymmetric: true,
  },
  {
    id: 5,
    tier: 3,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
    ],
    nameDe: "Haken",
    mirrorSymmetric: false,
  },
  {
    id: 6,
    tier: 3,
    cells: [
      [0, 0],
      [0, 1],
      [1, 2],
    ],
    nameDe: "Stufe",
    mirrorSymmetric: false,
  },
  {
    id: 7,
    tier: 3,
    cells: [
      [0, 0],
      [0, 2],
      [1, 1],
    ],
    nameDe: "Brücke",
    mirrorSymmetric: true,
  },
  {
    id: 8,
    tier: 3,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
    ],
    nameDe: "Ecke",
    mirrorSymmetric: false,
  },
  {
    id: 9,
    tier: 3,
    cells: [
      [0, 0],
      [1, 0],
      [2, 0],
    ],
    nameDe: "Turm",
    mirrorSymmetric: true,
  },
  {
    id: 10,
    tier: 3,
    cells: [
      [0, 0],
      [1, 0],
      [2, 1],
    ],
    nameDe: "Treppe",
    mirrorSymmetric: false,
  },
  {
    id: 11,
    tier: 3,
    cells: [
      [0, 0],
      [1, 1],
      [1, 2],
    ],
    nameDe: "Blitz",
    mirrorSymmetric: false,
  },
  {
    id: 12,
    tier: 3,
    cells: [
      [0, 0],
      [1, 1],
      [2, 0],
    ],
    nameDe: "Zickzack",
    mirrorSymmetric: false,
  },
  {
    id: 13,
    tier: 3,
    cells: [
      [0, 0],
      [1, 1],
      [2, 1],
    ],
    nameDe: "Ranke",
    mirrorSymmetric: false,
  },
  {
    id: 14,
    tier: 3,
    cells: [
      [0, 0],
      [1, 1],
      [2, 2],
    ],
    nameDe: "Diagonale",
    mirrorSymmetric: false,
  },
  {
    id: 15,
    tier: 3,
    cells: [
      [0, 1],
      [1, 0],
      [1, 2],
    ],
    nameDe: "Krone",
    mirrorSymmetric: true,
  },
  {
    id: 16,
    tier: 4,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
    ],
    nameDe: "Pfote",
    mirrorSymmetric: false,
  },
  {
    id: 17,
    tier: 4,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 1],
    ],
    nameDe: "Kreuz",
    mirrorSymmetric: true,
  },
  {
    id: 18,
    tier: 4,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
    ],
    nameDe: "Block",
    mirrorSymmetric: true,
  },
  {
    id: 19,
    tier: 4,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 2],
    ],
    nameDe: "Pranke",
    mirrorSymmetric: false,
  },
  {
    id: 20,
    tier: 4,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [2, 0],
    ],
    nameDe: "Klippe",
    mirrorSymmetric: false,
  },
  {
    id: 21,
    tier: 4,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [2, 1],
    ],
    nameDe: "Schlange",
    mirrorSymmetric: false,
  },
  {
    id: 22,
    tier: 4,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [1, 2],
    ],
    nameDe: "Welle",
    mirrorSymmetric: false,
  },
  {
    id: 23,
    tier: 4,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [2, 2],
    ],
    nameDe: "Fährte",
    mirrorSymmetric: false,
  },
  {
    id: 24,
    tier: 4,
    cells: [
      [0, 0],
      [0, 1],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Wirbel",
    mirrorSymmetric: false,
  },
  {
    id: 25,
    tier: 4,
    cells: [
      [0, 0],
      [0, 1],
      [1, 2],
      [2, 2],
    ],
    nameDe: "Schwanz",
    mirrorSymmetric: false,
  },
  {
    id: 26,
    tier: 4,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
    ],
    nameDe: "Flügel",
    mirrorSymmetric: false,
  },
  {
    id: 27,
    tier: 4,
    cells: [
      [0, 0],
      [0, 2],
      [1, 1],
      [2, 0],
    ],
    nameDe: "Anker",
    mirrorSymmetric: false,
  },
  {
    id: 28,
    tier: 4,
    cells: [
      [0, 0],
      [0, 2],
      [1, 1],
      [2, 1],
    ],
    nameDe: "Raute",
    mirrorSymmetric: true,
  },
  {
    id: 29,
    tier: 4,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [1, 2],
    ],
    nameDe: "Sockel",
    mirrorSymmetric: false,
  },
  {
    id: 30,
    tier: 4,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [2, 0],
    ],
    nameDe: "Faust",
    mirrorSymmetric: false,
  },
  {
    id: 31,
    tier: 4,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [2, 1],
    ],
    nameDe: "Spirale",
    mirrorSymmetric: false,
  },
  {
    id: 32,
    tier: 4,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [2, 2],
    ],
    nameDe: "Bumerang",
    mirrorSymmetric: false,
  },
  {
    id: 33,
    tier: 4,
    cells: [
      [0, 0],
      [1, 0],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Spinne",
    mirrorSymmetric: false,
  },
  {
    id: 34,
    tier: 4,
    cells: [
      [0, 0],
      [1, 0],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Stamm",
    mirrorSymmetric: false,
  },
  {
    id: 35,
    tier: 4,
    cells: [
      [0, 0],
      [1, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Wurzel",
    mirrorSymmetric: false,
  },
  {
    id: 36,
    tier: 4,
    cells: [
      [0, 0],
      [1, 1],
      [1, 2],
      [2, 0],
    ],
    nameDe: "Spiegel",
    mirrorSymmetric: false,
  },
  {
    id: 37,
    tier: 4,
    cells: [
      [0, 0],
      [1, 1],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Tropfen",
    mirrorSymmetric: false,
  },
  {
    id: 38,
    tier: 4,
    cells: [
      [0, 0],
      [1, 1],
      [1, 2],
      [2, 2],
    ],
    nameDe: "Pfeil",
    mirrorSymmetric: false,
  },
  {
    id: 39,
    tier: 4,
    cells: [
      [0, 0],
      [1, 1],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Klammer",
    mirrorSymmetric: false,
  },
  {
    id: 40,
    tier: 4,
    cells: [
      [0, 0],
      [1, 1],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Gabel",
    mirrorSymmetric: false,
  },
  {
    id: 41,
    tier: 4,
    cells: [
      [0, 0],
      [1, 1],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Schaufel",
    mirrorSymmetric: false,
  },
  {
    id: 42,
    tier: 4,
    cells: [
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
    ],
    nameDe: "Pilz",
    mirrorSymmetric: true,
  },
  {
    id: 43,
    tier: 4,
    cells: [
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 2],
    ],
    nameDe: "Halbmond",
    mirrorSymmetric: false,
  },
  {
    id: 44,
    tier: 4,
    cells: [
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 0],
    ],
    nameDe: "Kralle",
    mirrorSymmetric: false,
  },
  {
    id: 45,
    tier: 4,
    cells: [
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Sanduhr",
    mirrorSymmetric: true,
  },
  {
    id: 46,
    tier: 4,
    cells: [
      [0, 1],
      [1, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Ast",
    mirrorSymmetric: false,
  },
  {
    id: 47,
    tier: 4,
    cells: [
      [0, 1],
      [1, 1],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Auge",
    mirrorSymmetric: true,
  },
  {
    id: 48,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
    ],
    nameDe: "Schild",
    mirrorSymmetric: false,
  },
  {
    id: 49,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 2],
    ],
    nameDe: "Festung",
    mirrorSymmetric: true,
  },
  {
    id: 50,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [2, 0],
    ],
    nameDe: "Bastion",
    mirrorSymmetric: false,
  },
  {
    id: 51,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [2, 1],
    ],
    nameDe: "Kompass",
    mirrorSymmetric: false,
  },
  {
    id: 52,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 1],
      [2, 0],
    ],
    nameDe: "Fackel",
    mirrorSymmetric: false,
  },
  {
    id: 53,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 1],
      [2, 1],
    ],
    nameDe: "Laterne",
    mirrorSymmetric: true,
  },
  {
    id: 54,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
    ],
    nameDe: "Amboss",
    mirrorSymmetric: false,
  },
  {
    id: 55,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 0],
    ],
    nameDe: "Panzer",
    mirrorSymmetric: false,
  },
  {
    id: 56,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 2],
    ],
    nameDe: "Zinne",
    mirrorSymmetric: false,
  },
  {
    id: 57,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 0],
    ],
    nameDe: "Greif",
    mirrorSymmetric: false,
  },
  {
    id: 58,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Krabbe",
    mirrorSymmetric: false,
  },
  {
    id: 59,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 2],
    ],
    nameDe: "Skorpion",
    mirrorSymmetric: false,
  },
  {
    id: 60,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Mauer",
    mirrorSymmetric: false,
  },
  {
    id: 61,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Dolch",
    mirrorSymmetric: false,
  },
  {
    id: 62,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [1, 2],
      [2, 0],
    ],
    nameDe: "Blatt",
    mirrorSymmetric: false,
  },
  {
    id: 63,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Wolke",
    mirrorSymmetric: false,
  },
  {
    id: 64,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [1, 2],
      [2, 2],
    ],
    nameDe: "Kette",
    mirrorSymmetric: false,
  },
  {
    id: 65,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Dreizack",
    mirrorSymmetric: false,
  },
  {
    id: 66,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Flosse",
    mirrorSymmetric: false,
  },
  {
    id: 67,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Schwinge",
    mirrorSymmetric: false,
  },
  {
    id: 68,
    tier: 5,
    cells: [
      [0, 0],
      [0, 1],
      [1, 2],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Natter",
    mirrorSymmetric: false,
  },
  {
    id: 69,
    tier: 5,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
    ],
    nameDe: "Helm",
    mirrorSymmetric: true,
  },
  {
    id: 70,
    tier: 5,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 0],
    ],
    nameDe: "Hammer",
    mirrorSymmetric: false,
  },
  {
    id: 71,
    tier: 5,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 1],
    ],
    nameDe: "Kelch",
    mirrorSymmetric: false,
  },
  {
    id: 72,
    tier: 5,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 2],
    ],
    nameDe: "Zange",
    mirrorSymmetric: false,
  },
  {
    id: 73,
    tier: 5,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Käfig",
    mirrorSymmetric: true,
  },
  {
    id: 74,
    tier: 5,
    cells: [
      [0, 0],
      [0, 2],
      [1, 1],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Waage",
    mirrorSymmetric: false,
  },
  {
    id: 75,
    tier: 5,
    cells: [
      [0, 0],
      [0, 2],
      [1, 1],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Stern",
    mirrorSymmetric: true,
  },
  {
    id: 76,
    tier: 5,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
    ],
    nameDe: "Burg",
    mirrorSymmetric: false,
  },
  {
    id: 77,
    tier: 5,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Altar",
    mirrorSymmetric: false,
  },
  {
    id: 78,
    tier: 5,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 2],
    ],
    nameDe: "Schwert",
    mirrorSymmetric: false,
  },
  {
    id: 79,
    tier: 5,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Klotz",
    mirrorSymmetric: false,
  },
  {
    id: 80,
    tier: 5,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Zahn",
    mirrorSymmetric: false,
  },
  {
    id: 81,
    tier: 5,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Muschel",
    mirrorSymmetric: false,
  },
  {
    id: 82,
    tier: 5,
    cells: [
      [0, 0],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Horn",
    mirrorSymmetric: false,
  },
  {
    id: 83,
    tier: 5,
    cells: [
      [0, 0],
      [1, 0],
      [1, 2],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Nautilus",
    mirrorSymmetric: false,
  },
  {
    id: 84,
    tier: 5,
    cells: [
      [0, 0],
      [1, 0],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Turmbau",
    mirrorSymmetric: false,
  },
  {
    id: 85,
    tier: 5,
    cells: [
      [0, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Schloss",
    mirrorSymmetric: false,
  },
  {
    id: 86,
    tier: 5,
    cells: [
      [0, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Sense",
    mirrorSymmetric: false,
  },
  {
    id: 87,
    tier: 5,
    cells: [
      [0, 0],
      [1, 1],
      [1, 2],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Drache",
    mirrorSymmetric: false,
  },
  {
    id: 88,
    tier: 5,
    cells: [
      [0, 0],
      [1, 1],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Fundament",
    mirrorSymmetric: false,
  },
  {
    id: 89,
    tier: 5,
    cells: [
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
    ],
    nameDe: "Fahne",
    mirrorSymmetric: false,
  },
  {
    id: 90,
    tier: 5,
    cells: [
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Totem",
    mirrorSymmetric: true,
  },
  {
    id: 91,
    tier: 5,
    cells: [
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Geweih",
    mirrorSymmetric: false,
  },
  {
    id: 92,
    tier: 5,
    cells: [
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Flöte",
    mirrorSymmetric: false,
  },
  {
    id: 93,
    tier: 5,
    cells: [
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Schere",
    mirrorSymmetric: false,
  },
  {
    id: 94,
    tier: 5,
    cells: [
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Schmetterling",
    mirrorSymmetric: true,
  },
  {
    id: 95,
    tier: 5,
    cells: [
      [0, 1],
      [1, 0],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Bogen",
    mirrorSymmetric: false,
  },
  {
    id: 96,
    tier: 5,
    cells: [
      [0, 1],
      [1, 1],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Pfeiler",
    mirrorSymmetric: true,
  },
  {
    id: 97,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
    ],
    nameDe: "Monolith",
    mirrorSymmetric: true,
  },
  {
    id: 98,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 0],
    ],
    nameDe: "Bollwerk",
    mirrorSymmetric: false,
  },
  {
    id: 99,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 1],
    ],
    nameDe: "Thron",
    mirrorSymmetric: false,
  },
  {
    id: 100,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 2],
    ],
    nameDe: "Tsunami",
    mirrorSymmetric: false,
  },
  {
    id: 101,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 2],
      [2, 0],
    ],
    nameDe: "Golem",
    mirrorSymmetric: false,
  },
  {
    id: 102,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Tempel",
    mirrorSymmetric: true,
  },
  {
    id: 103,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Donner",
    mirrorSymmetric: false,
  },
  {
    id: 104,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Flut",
    mirrorSymmetric: false,
  },
  {
    id: 105,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 1],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Diadem",
    mirrorSymmetric: false,
  },
  {
    id: 106,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 1],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Obelisk",
    mirrorSymmetric: true,
  },
  {
    id: 107,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
    ],
    nameDe: "Lawine",
    mirrorSymmetric: false,
  },
  {
    id: 108,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Lotse",
    mirrorSymmetric: false,
  },
  {
    id: 109,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 2],
    ],
    nameDe: "Gezeiten",
    mirrorSymmetric: false,
  },
  {
    id: 110,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Koloss",
    mirrorSymmetric: true,
  },
  {
    id: 111,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Hydra",
    mirrorSymmetric: false,
  },
  {
    id: 112,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Chimäre",
    mirrorSymmetric: false,
  },
  {
    id: 113,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Wächter",
    mirrorSymmetric: false,
  },
  {
    id: 114,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Mantis",
    mirrorSymmetric: false,
  },
  {
    id: 115,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Phantom",
    mirrorSymmetric: false,
  },
  {
    id: 116,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Vulkan",
    mirrorSymmetric: false,
  },
  {
    id: 117,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Wiege",
    mirrorSymmetric: false,
  },
  {
    id: 118,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Kraken",
    mirrorSymmetric: false,
  },
  {
    id: 119,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [1, 2],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Schlund",
    mirrorSymmetric: false,
  },
  {
    id: 120,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Titan",
    mirrorSymmetric: false,
  },
  {
    id: 121,
    tier: 6,
    cells: [
      [0, 0],
      [0, 1],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Phönix",
    mirrorSymmetric: false,
  },
  {
    id: 122,
    tier: 6,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
    ],
    nameDe: "Greifvogel",
    mirrorSymmetric: false,
  },
  {
    id: 123,
    tier: 6,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Kathedrale",
    mirrorSymmetric: true,
  },
  {
    id: 124,
    tier: 6,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Zitadelle",
    mirrorSymmetric: false,
  },
  {
    id: 125,
    tier: 6,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Sphinx",
    mirrorSymmetric: false,
  },
  {
    id: 126,
    tier: 6,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Leviathan",
    mirrorSymmetric: false,
  },
  {
    id: 127,
    tier: 6,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Skarabäus",
    mirrorSymmetric: false,
  },
  {
    id: 128,
    tier: 6,
    cells: [
      [0, 0],
      [0, 2],
      [1, 1],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Portal",
    mirrorSymmetric: true,
  },
  {
    id: 129,
    tier: 6,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Mammut",
    mirrorSymmetric: false,
  },
  {
    id: 130,
    tier: 6,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Zerberus",
    mirrorSymmetric: false,
  },
  {
    id: 131,
    tier: 6,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Behemoth",
    mirrorSymmetric: false,
  },
  {
    id: 132,
    tier: 6,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Erdkern",
    mirrorSymmetric: false,
  },
  {
    id: 133,
    tier: 6,
    cells: [
      [0, 0],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Fossil",
    mirrorSymmetric: false,
  },
  {
    id: 134,
    tier: 6,
    cells: [
      [0, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Ursprung",
    mirrorSymmetric: false,
  },
  {
    id: 135,
    tier: 6,
    cells: [
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Banshee",
    mirrorSymmetric: false,
  },
  {
    id: 136,
    tier: 6,
    cells: [
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Wyvern",
    mirrorSymmetric: true,
  },
  {
    id: 137,
    tier: 6,
    cells: [
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Gorgone",
    mirrorSymmetric: false,
  },
  {
    id: 138,
    tier: 6,
    cells: [
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Idol",
    mirrorSymmetric: true,
  },
  {
    id: 139,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
    ],
    nameDe: "Sturmkönig",
    mirrorSymmetric: false,
  },
  {
    id: 140,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 1],
    ],
    nameDe: "Kronprinz",
    mirrorSymmetric: true,
  },
  {
    id: 141,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Wellenbrecher",
    mirrorSymmetric: false,
  },
  {
    id: 142,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Donnervogel",
    mirrorSymmetric: false,
  },
  {
    id: 143,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Gezeitenfürst",
    mirrorSymmetric: false,
  },
  {
    id: 144,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Drachenlord",
    mirrorSymmetric: false,
  },
  {
    id: 145,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Erzengel",
    mirrorSymmetric: true,
  },
  {
    id: 146,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Urgewalt",
    mirrorSymmetric: false,
  },
  {
    id: 147,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 1],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Weltentor",
    mirrorSymmetric: true,
  },
  {
    id: 148,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Schildwall",
    mirrorSymmetric: false,
  },
  {
    id: 149,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Kriegsherr",
    mirrorSymmetric: false,
  },
  {
    id: 150,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Sturmflut",
    mirrorSymmetric: false,
  },
  {
    id: 151,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Erdmutter",
    mirrorSymmetric: false,
  },
  {
    id: 152,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Seelenfresser",
    mirrorSymmetric: false,
  },
  {
    id: 153,
    tier: 7,
    cells: [
      [0, 0],
      [0, 1],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Tiefenwurm",
    mirrorSymmetric: false,
  },
  {
    id: 154,
    tier: 7,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Titanenschild",
    mirrorSymmetric: false,
  },
  {
    id: 155,
    tier: 7,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Runenwächter",
    mirrorSymmetric: true,
  },
  {
    id: 156,
    tier: 7,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Abgrund",
    mirrorSymmetric: false,
  },
  {
    id: 157,
    tier: 7,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Leere",
    mirrorSymmetric: true,
  },
  {
    id: 158,
    tier: 7,
    cells: [
      [0, 0],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Bergkönig",
    mirrorSymmetric: false,
  },
  {
    id: 159,
    tier: 7,
    cells: [
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Weltenseele",
    mirrorSymmetric: true,
  },
  {
    id: 160,
    tier: 8,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
    ],
    nameDe: "Archon",
    mirrorSymmetric: false,
  },
  {
    id: 161,
    tier: 8,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 2],
    ],
    nameDe: "Ätherkrone",
    mirrorSymmetric: true,
  },
  {
    id: 162,
    tier: 8,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Schicksalstor",
    mirrorSymmetric: false,
  },
  {
    id: 163,
    tier: 8,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Ewiges Auge",
    mirrorSymmetric: true,
  },
  {
    id: 164,
    tier: 8,
    cells: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Urflut",
    mirrorSymmetric: false,
  },
  {
    id: 165,
    tier: 8,
    cells: [
      [0, 0],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Lebensfunke",
    mirrorSymmetric: true,
  },
  {
    id: 166,
    tier: 9,
    cells: [
      [0, 0],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 1],
      [1, 2],
      [2, 0],
      [2, 1],
      [2, 2],
    ],
    nameDe: "Vollkommen",
    mirrorSymmetric: true,
  },
];
